import React, { useState, useEffect, useContext } from "react";
import { AnchorComponent, ButtonComponent } from "../elements";
import { TranslatorContext } from "../../context/Translator";
import moment from 'moment-timezone';
import { useNavigate } from "react-router-dom";
import { deleteUserType } from "../../APIs/UserTypeRequests";
import { toast } from 'react-toastify';
import { Button, Modal } from "react-bootstrap";


export default function UserTypesTableComponent({ thead, tbody,refreshPage,openEditModal }) {

    const { t } = useContext(TranslatorContext);
        const navigate = useNavigate();
    
    const [data, setData] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deletingUserType, setDeletingUserType] = useState(null);

    useEffect(()=> { setData(tbody) }, [tbody]);

    
    const handleRowClick = (item) => {
        navigate(`/user-types/${item.id}`);
    };

    // Handle delete
    const openDeleteModal = (userType) => {
        setDeletingUserType(userType);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setDeletingUserType(null);
    };
    const handleDelete = async () => {
        if (!deletingUserType) return;

        try {
            await deleteUserType(deletingUserType.id);
            toast.success(t('user_type_deleted') || 'User type deleted successfully');
            closeDeleteModal();
            refreshPage(); // Refresh the page or data after deletion
        } catch (error) {
            console.error('Error deleting user type:', error);
            toast.error(t('error_deleting_data') || 'Error deleting data');
        }
    };
    return (
        <div className="mc-table-responsive">
            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead.map((item, index) => (
                            <th key={ index }>{ item }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data?.map((item, index) => {
                        return (
                            <tr key={ index }> 
                                <td title={ item.name }>
                                    <div className="mc-table-profile">
                                        <p>{ item.name }</p>
                                    </div>
                                </td>
        
                                <td title={ item.created }>{ moment.utc(item.created_at).local().format('yyyy-MM-DD HH:mm:ss') }</td>
                                <td>
                                    {
                                        localStorage.getItem('permissions').includes('update user type') && 
                                        <AnchorComponent onClick={() => openEditModal(item)} to={'#'} title="Update" className="material-icons edit">{ "edit" }</AnchorComponent>
                                    }
                                    <AnchorComponent onClick={() => handleRowClick(item)} to={'#'} title="View" className="material-icons view">{ "visibility" }</AnchorComponent>
                                    {
                                        localStorage.getItem('permissions').includes('delete user type') && 
                                        <AnchorComponent onClick={() => openDeleteModal(item)} to={'#'} title="Delete" className="material-icons delete">{ "delete" }</AnchorComponent>
                                    }
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={closeDeleteModal}>
                <Modal.Header closeButton style={{padding: '10px'}}>
                    <Modal.Title>{t('confirm_delete') || 'Confirm Delete'}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{padding: '10px'}}>
                    {t('delete_user_type_confirmation') || 'Are you sure you want to delete this user type?'} 
                    {deletingUserType && (
                        <strong> "{deletingUserType.name}"</strong>
                    )}
                </Modal.Body>
                <Modal.Footer style={{padding: '10px'}}>
                    <Button variant="secondary" onClick={closeDeleteModal}>
                        {t('cancel') || 'Cancel'}
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        {t('delete') || 'Delete'}
                    </Button>
                </Modal.Footer>
            </Modal>
           
            
        </div>
    )
}